import AccessTime from '@material-ui/icons/AccessTime';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Alarm from '@material-ui/icons/Alarm';
import Assignment from '@material-ui/icons/Assignment';
import AssignmentInd from '@material-ui/icons/AssignmentInd';
import TimerIcon from '@material-ui/icons/AvTimer';
import BuildIcon from '@material-ui/icons/Build';
import CalendarToday from '@material-ui/icons/CalendarToday';
import CalendarViewDay from '@material-ui/icons/CalendarViewDay';
import CommentIcon from '@material-ui/icons/Comment';
import CreditCard from '@material-ui/icons/CreditCard';
import ActionDashboard from '@material-ui/icons/Dashboard';
import DescriptionIcon from '@material-ui/icons/Description';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import DeveloperBoardIcon from '@material-ui/icons/DeveloperBoard';
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import EventIcon from '@material-ui/icons/Event';
import FlightTakeoffIcon from '@material-ui/icons/FlightTakeoff';
import Gavel from '@material-ui/icons/Gavel';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import HistoryIcon from '@material-ui/icons/History';
import Home from '@material-ui/icons/Home';
import ImportantDevicesIcon from '@material-ui/icons/ImportantDevices';
import InfoIcon from '@material-ui/icons/Info';
import LocalCafeIcon from '@material-ui/icons/LocalCafe';
import Lock from '@material-ui/icons/Lock';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import PersonIcon from '@material-ui/icons/Person';
import RecentActorsIcon from '@material-ui/icons/RecentActors';
import RedeemIcon from '@material-ui/icons/Redeem';
import RoomIcon from '@material-ui/icons/Room';
import SettingsApp from '@material-ui/icons/SettingsApplications';
import Settings from '@material-ui/icons/SettingsSharp';
import ShopTwo from '@material-ui/icons/ShopTwo';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import TableChartIcon from '@material-ui/icons/TableChart';
import TimelapseIcon from '@material-ui/icons/Timelapse';
import TimeLine from '@material-ui/icons/Timeline';
import Tv from '@material-ui/icons/Tv';
import ViewList from '@material-ui/icons/ViewList';
import ViewModule from '@material-ui/icons/ViewModule';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import Work from '@material-ui/icons/Work';
import { mainReportV1AccessCheck, mainReportV2AccessCheck, plannerAccessCheck, plannerPolicyAccessCheck } from 'src/routes/accessControllers';
import { FlagFrom } from 'src/routes/interfaces';
export const homeRoute = {
    selectedTabId: 'Firstpage',
    link: '/',
    icon: Home
};
export const employees = {
    selectedTabId: 'Employees',
    link: '/employees',
    icon: AssignmentInd,
    rightFlag: 'userAdministration',
    flagFrom: FlagFrom.Read,
    subPages: [{
            selectedTabId: 'EmployeesRequests',
            link: '/employeesRequests',
            icon: EmojiPeopleIcon,
            rightFlag: 'plannerRequestAdministration',
            flagFrom: FlagFrom.Read,
            moduleFlag: 'PlannerRequests',
            moduleConfigDependencies: [{
                    moduleFlag: 'Planner',
                    propertyPath: 'EmployeesRequests'
                }]
        }, {
            selectedTabId: 'Statements',
            link: '/statements',
            icon: DescriptionIcon,
            rightFlag: 'requestAdministration',
            flagFrom: FlagFrom.Read,
            moduleFlag: 'SelfService'
        }, {
            selectedTabId: 'Table',
            link: '/table',
            icon: AssignmentInd,
            rightFlag: 'userAdministration',
            flagFrom: FlagFrom.Read
        }, {
            selectedTabId: 'Contracts',
            link: '/contracts',
            icon: AssignmentInd,
            rightFlag: 'userContracts',
            flagFrom: FlagFrom.Read,
            moduleFlag: 'UserContracts'
        }]
};
export const projects = {
    selectedTabId: 'Projects',
    link: '/projects',
    icon: Work,
    rightFlag: 'projectAdministration',
    flagFrom: FlagFrom.Read,
    moduleFlag: 'Projects'
};
export const planner = {
    selectedTabId: 'Planner',
    link: '/planner',
    icon: ActionDashboard,
    rightFlag: 'planner',
    flagFrom: FlagFrom.Read,
    moduleFlag: 'Planner',
    accessController: () => plannerAccessCheck({ isNew: false })
};
export const advancedPlanner = {
    selectedTabId: 'AdvancedPlanner',
    link: '/advancedPlanner',
    icon: ActionDashboard,
    rightFlag: 'planner',
    flagFrom: FlagFrom.Read,
    moduleFlag: 'Planner',
    accessController: () => plannerAccessCheck({ isNew: true })
};
export const absences = {
    selectedTabId: 'Absences',
    link: '/absences',
    icon: FlightTakeoffIcon,
    rightFlag: 'vacations',
    flagFrom: FlagFrom.Read,
    moduleFlag: 'Vacations'
};
export const rewardRegistry = {
    selectedTabId: 'RewardRegistry',
    link: '/rewardRegistry',
    icon: Assignment,
    rightFlag: 'bonusEntry',
    flagFrom: FlagFrom.Read,
    moduleFlag: 'Bonus'
};
export const calendar = {
    selectedTabId: 'Calendar',
    link: '/calendar',
    icon: CalendarToday,
    rightFlag: 'calendarAdministration',
    flagFrom: FlagFrom.Read,
    moduleFlag: 'Calendar',
    subPages: [{
            selectedTabId: 'PersonCalendar',
            link: '/personCalendar',
            icon: CalendarToday,
            moduleFlag: 'Calendar'
        }, {
            selectedTabId: 'FaultyEvents',
            link: '/faultyEvents',
            icon: CalendarViewDay,
            moduleFlag: 'Calendar'
        }, {
            selectedTabId: 'CalendarEventsLog',
            link: '/calendarEventsLog',
            icon: CalendarViewDay,
            moduleFlag: 'Calendar',
            rightFlag: 'calendarEventsLog',
            flagFrom: FlagFrom.Visible
        }]
};
export const timeTable = {
    selectedTabId: 'TimeTable',
    link: '/timeTable',
    icon: TableChartIcon
    // moduleFlag: 'TimeTable'
};
export const reports = {
    selectedTabId: 'Reports',
    link: '/reports',
    icon: Assignment,
    subPages: [{
            selectedTabId: 'TableHistoryReport',
            link: '/tableHistoryReport',
            icon: HistoryIcon,
            rightFlag: 'tableHistoryReport',
            flagFrom: FlagFrom.Visible
        },
        {
            selectedTabId: 'RewardReport',
            link: '/rewardReport',
            icon: Assignment,
            rightFlag: 'bonusEntry',
            flagFrom: FlagFrom.Read,
            moduleFlag: 'Bonus'
        },
        {
            selectedTabId: 'EmployeesReport',
            link: '/employeesReport',
            icon: ActionDashboard,
            moduleFlag: 'DepartmentsWorkTimesByJobsReport',
            rightFlag: 'productivityReport',
            flagFrom: FlagFrom.Visible
        },
        {
            selectedTabId: 'WorksInProjectsReport',
            link: '/worksInProjectsReport',
            moduleFlag: 'Projects',
            icon: Assignment,
            rightFlag: 'projectsByJobsReport',
            flagFrom: FlagFrom.Visible
        },
        {
            selectedTabId: 'WorksInOtherDepartmentsReport',
            link: '/worksInOtherDepartmentsReport',
            icon: AssignmentInd,
            rightFlag: 'movementBetweenDepartmentsReport',
            flagFrom: FlagFrom.Visible
        },
        {
            selectedTabId: 'WorksReport',
            link: '/worksReport',
            icon: TimeLine,
            rightFlag: 'worktimesInDepartmentsReport',
            flagFrom: FlagFrom.Visible
        },
        {
            selectedTabId: 'WorkTimesReport',
            link: '/workTimesReport',
            icon: AccessTime,
            rightFlag: 'workTimesInPeriodByJobsReport',
            flagFrom: FlagFrom.Visible
        },
        {
            selectedTabId: 'WorkAndAbsencesReport',
            link: '/workAndAbsencesReport',
            icon: AccessTime,
            moduleFlag: 'WorkTimesByUsersReport',
            rightFlag: 'workTimesByUsersReport',
            flagFrom: FlagFrom.Visible
        },
        {
            selectedTabId: 'WorkByDaysReport',
            link: '/workByDaysReport',
            icon: AccessTime,
            rightFlag: 'workByDaysReport',
            flagFrom: FlagFrom.Visible
        },
        {
            selectedTabId: 'MachineTimesReport',
            link: '/machineTimesReport',
            icon: Assignment,
            moduleFlag: 'MachineTimes',
            rightFlag: 'machineTimesReport',
            flagFrom: FlagFrom.Visible
        },
        {
            selectedTabId: 'ExportToAxaptaReport',
            link: '/exportToAxaptaReport',
            icon: Assignment,
            moduleFlag: 'Axapta',
            rightFlag: 'workingHoursExportValuesReport',
            flagFrom: FlagFrom.Visible
        },
        {
            selectedTabId: 'MainReportOld',
            link: '/mainReportOld',
            icon: Assignment,
            moduleFlag: 'MainReport',
            rightFlag: 'mainReport',
            flagFrom: FlagFrom.Visible,
            accessController: mainReportV1AccessCheck
        },
        {
            selectedTabId: 'MainReport',
            link: '/mainReport',
            icon: Assignment,
            moduleFlag: 'MainReport',
            rightFlag: 'mainReport',
            flagFrom: FlagFrom.Visible,
            accessController: mainReportV2AccessCheck
        },
        {
            selectedTabId: 'SummaryReport',
            link: '/summaryReport',
            icon: Assignment,
            rightFlag: 'summaryReport',
            flagFrom: FlagFrom.Visible
        },
        {
            selectedTabId: 'DetailedSummaryReport',
            link: '/detailedSummaryReport',
            icon: Assignment,
            moduleFlag: 'DetailedSummaryReport',
            rightFlag: 'detailedSummaryReport',
            flagFrom: FlagFrom.Visible,
            moduleConfigDependencies: [{
                    moduleFlag: 'UserContracts',
                    propertyPath: 'ContractLineDepartment'
                }]
        },
        {
            selectedTabId: 'ArgosEventsLogReport',
            link: '/argosEventsLogReport',
            icon: Assignment,
            rightFlag: 'argosEventsLog',
            flagFrom: FlagFrom.Visible
        },
        {
            selectedTabId: 'UnscheduledWork',
            link: '/unscheduledWork',
            icon: Assignment,
            rightFlag: 'offScheduleReport',
            flagFrom: FlagFrom.Visible
        }, {
            selectedTabId: 'LawReport',
            link: '/lawReport',
            icon: Gavel,
            rightFlag: 'lawReport',
            flagFrom: FlagFrom.Visible
        }, {
            selectedTabId: 'FlexibleWorkTimeMonitoringReport',
            link: '/flexibleWorkTimeMonitoringReport',
            icon: TimelapseIcon,
            rightFlag: 'mainReport',
            flagFrom: FlagFrom.Visible,
            moduleConfigDependencies: [{
                    moduleFlag: 'UserContracts',
                    propertyPath: 'FlexibleWorkTime'
                }]
        }]
};
export const passages = {
    selectedTabId: 'Passages',
    link: '/passages',
    icon: MeetingRoomIcon,
    moduleFlag: 'Passages',
    subPages: [{
            selectedTabId: 'PassagesCalendar',
            nameKey: 'Calendar',
            // The Passages tile texts are the *Descriptions keys; CalendarDescription is the work time calendar's
            description: 'CalendarDescriptions',
            link: '/calendar',
            icon: CalendarToday,
            rightFlag: 'manualDoorOperations',
            flagFrom: FlagFrom.Read,
            moduleFlag: 'Passages'
        }, {
            selectedTabId: 'DoorOperatingModes',
            description: 'DoorOperatingModesDescriptions',
            link: '/doorOperatingModes',
            icon: SettingsApp,
            rightFlag: 'accessOperatingModes',
            flagFrom: FlagFrom.Read,
            moduleFlag: 'Passages'
        }, {
            selectedTabId: 'PassageGroups',
            description: 'PassageGroupsDescriptions',
            link: '/passageGroups',
            icon: GroupWorkIcon,
            rightFlag: 'accessGroups',
            flagFrom: FlagFrom.Read,
            moduleFlag: 'Passages'
        }, {
            selectedTabId: 'Controllers',
            description: 'ControllersDescriptions',
            link: '/controllers',
            icon: DeveloperBoardIcon,
            rightFlag: 'controllers',
            flagFrom: FlagFrom.Read,
            moduleFlag: 'Passages'
        }, {
            selectedTabId: 'Events',
            description: 'EventsDescriptions',
            link: '/events',
            icon: EventIcon,
            rightFlag: 'accessEvents',
            flagFrom: FlagFrom.Read,
            moduleFlag: 'Passages'
        }, {
            selectedTabId: 'MasterKeys',
            description: 'MasterKeysDescriptions',
            link: '/masterKeys',
            icon: VpnKeyIcon,
            rightFlag: 'accessMasterKeys',
            flagFrom: FlagFrom.Read,
            moduleFlag: 'Passages'
        }, {
            // The LPS API checks this page's users, keys and access profiles against userAdministration
            selectedTabId: 'IdKeys',
            link: '/idKeys',
            icon: RecentActorsIcon,
            rightFlag: 'userAdministration',
            flagFrom: FlagFrom.Read,
            moduleFlag: 'Passages'
        }]
};
export const settings = {
    selectedTabId: 'Settings',
    link: '/settings',
    icon: Settings,
    subPages: [{
            selectedTabId: 'RequestTypes',
            link: '/requestTypes',
            icon: EmojiPeopleIcon,
            rightFlag: 'plannerRequestAdministration',
            flagFrom: FlagFrom.Read,
            moduleConfigDependencies: [{
                    moduleFlag: 'Planner',
                    propertyPath: 'EmployeesRequests'
                }]
        }, {
            selectedTabId: 'PlannerPolicy',
            link: '/plannerPolicy',
            icon: Gavel,
            moduleFlag: 'Planner',
            rightFlag: 'planner',
            flagFrom: FlagFrom.Read,
            accessController: plannerPolicyAccessCheck
        }, {
            selectedTabId: 'Comments',
            link: '/comments',
            icon: CommentIcon,
            rightFlag: 'jobComments',
            flagFrom: FlagFrom.Read
        }, {
            selectedTabId: 'CompensationProducts',
            link: '/compensationProducts',
            icon: LocalCafeIcon,
            rightFlag: 'compensations',
            flagFrom: FlagFrom.Read
        }, {
            selectedTabId: 'Configuration',
            link: '/configuration',
            icon: BuildIcon,
            rightFlag: 'configurationAdministration',
            flagFrom: FlagFrom.Read
        }, {
            selectedTabId: 'ApiClients',
            link: '/apiClients',
            icon: SupervisorAccountIcon,
            rightFlag: 'apiClientsAdministration',
            flagFrom: FlagFrom.Read,
            moduleFlag: 'ApiClients'
        }, {
            selectedTabId: 'WorkSites',
            link: '/workSites',
            icon: RoomIcon,
            rightFlag: 'worksites',
            flagFrom: FlagFrom.Read,
            moduleFlag: 'Worksites'
        }, {
            selectedTabId: 'Departments',
            link: '/departments',
            icon: ViewList,
            rightFlag: 'departmentAdministration',
            flagFrom: FlagFrom.Read
        }, {
            selectedTabId: 'DepartmentsTasks',
            link: '/departmentsTasks',
            icon: ViewList,
            rightFlag: 'departmentAdministration',
            flagFrom: FlagFrom.Read
        }, {
            selectedTabId: 'Shifts',
            link: '/shifts',
            icon: Alarm,
            rightFlag: 'workShifts',
            flagFrom: FlagFrom.Read,
            moduleFlag: 'WorkShifts'
        }, {
            selectedTabId: 'SlipTimes',
            link: '/slipTimes',
            moduleFlag: 'SlipTimes',
            icon: TimelapseIcon,
            rightFlag: 'slipTimes',
            flagFrom: FlagFrom.Read
        }, {
            selectedTabId: 'UserRights',
            link: '/userRight',
            icon: Lock,
            rightFlag: 'rightGroupAdministration',
            flagFrom: FlagFrom.Read
        },
        {
            selectedTabId: 'Profiles',
            link: '/jobProfiles',
            icon: AccountCircle,
            rightFlag: 'jobProfileAdministration',
            flagFrom: FlagFrom.Read
        },
        {
            selectedTabId: 'StandardHours',
            link: '/workDayEvents',
            icon: AccessTime,
            rightFlag: 'normalHoursAdministration',
            flagFrom: FlagFrom.Read
        },
        {
            selectedTabId: 'Actions',
            link: '/jobs',
            icon: Work,
            rightFlag: 'jobAdministration',
            flagFrom: FlagFrom.Read
        },
        {
            selectedTabId: 'ActionsTable',
            link: '/jobsTable',
            icon: Work,
            rightFlag: 'jobAdministration',
            flagFrom: FlagFrom.Read
        },
        {
            selectedTabId: 'ActionsRelations',
            link: '/jobsRelations',
            icon: Work,
            rightFlag: 'jobAdministration',
            flagFrom: FlagFrom.Read
        },
        {
            selectedTabId: 'AbsenceActions',
            link: '/jobAbsences',
            icon: Work,
            rightFlag: 'jobAdministration',
            flagFrom: FlagFrom.Read
        },
        {
            selectedTabId: 'AbsencesImportSettings',
            link: '/absencesImport',
            icon: ShopTwo,
            moduleFlagSomeOf: ['Columbus365', 'Pilvepalk'],
            rightFlag: 'absenceImportSettings',
            flagFrom: FlagFrom.Read
        },
        {
            selectedTabId: 'Professions',
            link: '/professions',
            icon: Work,
            moduleFlag: 'Professions',
            rightFlag: 'professionsAdministration',
            flagFrom: FlagFrom.Read
        },
        {
            selectedTabId: 'Skills',
            link: '/skills',
            icon: Work,
            moduleFlag: 'Skills',
            rightFlag: 'skillsAdministration',
            flagFrom: FlagFrom.Read
        },
        {
            selectedTabId: 'StatementTypes',
            link: '/statementTypes',
            icon: DescriptionIcon,
            moduleFlag: 'SelfService',
            rightFlag: 'requestAdministration',
            flagFrom: FlagFrom.Read
        },
        {
            selectedTabId: 'Argos',
            link: '/importFromArgos',
            icon: Assignment,
            moduleFlag: 'Argos',
            rightFlag: 'importFromArgos',
            flagFrom: FlagFrom.Visible,
            moduleConfigDependencies: [{
                    moduleFlag: 'Argos',
                    propertyPath: 'ImportFromArgos'
                }]
        },
        {
            selectedTabId: 'tvManagement',
            link: '/tvManagement',
            icon: Tv,
            moduleFlag: 'TvGraphs',
            rightFlag: 'graphsAdministration',
            flagFrom: FlagFrom.Read
        },
        {
            selectedTabId: 'WCC',
            link: '/wccManagement',
            icon: SettingsApp,
            rightFlag: 'wccAdministration',
            flagFrom: FlagFrom.Read,
            moduleFlag: 'MachineTimes'
        },
        {
            selectedTabId: 'RenewStandardTimes',
            description: 'RenewStandardTimes2',
            link: '/RenewStandardTimes',
            icon: AccessTime,
            moduleFlag: 'MachineTimes',
            rightFlag: 'machineTimesImport',
            flagFrom: FlagFrom.Visible
        },
        {
            selectedTabId: 'Modules',
            link: '/modules',
            icon: ViewModule,
            rightFlag: 'configurationAdministration',
            flagFrom: FlagFrom.Read
        },
        {
            selectedTabId: 'SimpleRegistrars',
            link: '/simpleRegistrars',
            icon: ImportantDevicesIcon,
            moduleFlag: 'SimpleRegistrator',
            rightFlag: 'simpleRegistratorsAdministration',
            flagFrom: FlagFrom.Read
        },
        {
            selectedTabId: 'PaymentCodes',
            link: '/wccMot',
            icon: SettingsApp,
            moduleFlag: 'MachineTimes',
            rightFlag: 'paymentCodeAdministration',
            flagFrom: FlagFrom.Read
        },
        {
            selectedTabId: 'Law',
            link: '/law',
            icon: Gavel,
            moduleFlag: 'LawManagement',
            rightFlag: 'lawAdministration',
            flagFrom: FlagFrom.Read
        },
        {
            selectedTabId: 'RewardTypes',
            link: '/rewardTypes',
            icon: RedeemIcon,
            moduleFlag: 'Bonus',
            rightFlag: 'bonusAdministration',
            flagFrom: FlagFrom.Read
        },
        {
            selectedTabId: 'WorktimeTypes',
            link: '/workTimeTypes',
            icon: TimerIcon,
            rightFlag: 'workTimeCalculationTypes',
            flagFrom: FlagFrom.Read
        }]
};
export const documentation = {
    selectedTabId: 'Help',
    link: '/help',
    icon: InfoIcon
};
export const doorMonitoring = {
    selectedTabId: 'DoorMonitoring',
    link: '/doorMonitoring',
    icon: InfoIcon,
    moduleFlag: 'UserTracking'
};
export const offlineLockCards = {
    selectedTabId: 'OfflineLockCards',
    link: '/offlineLockCards',
    icon: CreditCard,
    moduleFlag: 'OfflineLock',
    rightFlag: 'offlineLock',
    flagFrom: FlagFrom.Read
};
export const selfServiceRouter = {
    selectedTabId: 'SelfService',
    link: '/selfService',
    icon: PersonIcon,
    subPages: [{
            selectedTabId: 'MyDashboard',
            link: '/myDashboard',
            icon: DesktopWindowsIcon,
            rightFlag: 'selfServiceDashboard',
            flagFrom: FlagFrom.Visible
        }, {
            selectedTabId: 'MyPlanner',
            link: '/myPlanner',
            icon: ActionDashboard,
            rightFlag: 'selfServicePlanner',
            flagFrom: FlagFrom.Visible
        }, {
            selectedTabId: 'MyAbsences',
            link: '/myAbsences',
            icon: FlightTakeoffIcon,
            rightFlag: 'selfServiceAbsences',
            flagFrom: FlagFrom.Visible
        }, {
            selectedTabId: 'MyEmployeesReport',
            link: '/myEmployeesReport',
            icon: ActionDashboard,
            rightFlag: 'selfServiceEmployeesReport',
            flagFrom: FlagFrom.Visible
        }, {
            selectedTabId: 'MyWorkByDaysReport',
            link: '/myWorkByDaysReport',
            icon: AccessTime,
            rightFlag: 'selfServiceWorkByDaysReport',
            flagFrom: FlagFrom.Visible
        }, {
            selectedTabId: 'MySummaryReport',
            link: '/mySummaryReport',
            icon: Assignment,
            rightFlag: 'selfServiceSummaryReport',
            flagFrom: FlagFrom.Visible
        }]
};
export const selfService = [selfServiceRouter, documentation];
export const routes = [
    employees,
    projects,
    planner,
    advancedPlanner,
    absences,
    calendar,
    timeTable,
    rewardRegistry,
    reports,
    passages,
    settings,
    doorMonitoring,
    offlineLockCards,
    { ...selfServiceRouter, moduleFlag: 'SelfService' },
    documentation
];
